import React from 'react';
import EditEventGalleryForm from '../../features/EventsGallery/component/EditEventGalleryForm';

const EditEventGallery= () => {
    return (<>
        <EditEventGalleryForm />
    </>)
}
export default EditEventGallery;